"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var operators_1 = require("rxjs/operators");
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var static_method_1 = require("../../utils/static-method");
var model_1 = require("@synisys/idm-document-service-client-js/app/model");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_document_service_client_js_1 = require("@synisys/idm-document-service-client-js");
var convert_operation_dto_1 = require("../../model/document-operation/convert-operation-dto");
var HttpDocumentOperationsService = /** @class */ (function () {
    function HttpDocumentOperationsService(http, deService, cookieService, messageService, documentService, kbService, applicationPropertiesService) {
        this.http = http;
        this.deService = deService;
        this.cookieService = cookieService;
        this.messageService = messageService;
        this.documentService = documentService;
        this.kbService = kbService;
        this.applicationPropertiesService = applicationPropertiesService;
        this.serviceUrlKey = 'ejustice-document-service-url';
        this.documentConvertPath = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/document-operations/convert"], ["", "/document-operations/convert"])), 'serviceUri');
        this.documentConvertPagePath = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "/document-operations/convert"], ["", "/document-operations/convert"])), 'serviceUri');
        this.createDocumentPath = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", "/document-operations/create"], ["", "/document-operations/create"])), 'serviceUri');
        this.serviceUrl$ = Observable_1.Observable.from(this.applicationPropertiesService.getProperty(this.serviceUrlKey));
    }
    HttpDocumentOperationsService.prototype.getInfo = function (attachmentId) {
        var _this = this;
        return this.documentService.getIsDocumentPresent(attachmentId).pipe(operators_1.switchMap(function (isConfirmed) {
            if (isConfirmed) {
                return _this.documentService.getDocumentInfo(attachmentId);
            }
            else {
                return _this.documentService.getTempDocumentInfo(attachmentId);
            }
        }));
    };
    /**
     * Gets confirmed or temporary document full URL of original document.
     */
    HttpDocumentOperationsService.prototype.getUrl = function (attachmentId, categoryId, entityId, fieldId) {
        var _this = this;
        return this.documentService.getIsDocumentPresent(attachmentId).pipe(operators_1.switchMap(function (isConfirmed) {
            if (isConfirmed) {
                return _this.deService.getDocumentToken(categoryId, entityId, fieldId)
                    .pipe(operators_1.switchMap(function (authInfo) { return _this.documentService.getDocumentUrl(attachmentId, authInfo, model_1.FileType.ORIGINAL); }));
            }
            else {
                return _this.documentService.getTempDocumentUrl(attachmentId, model_1.FileType.ORIGINAL);
            }
        }));
    };
    HttpDocumentOperationsService.prototype.downloadDocument = function (attachmentId, categoryId, entityId, fieldId) {
        var _this = this;
        return this.documentService.getIsDocumentPresent(attachmentId).pipe(operators_1.switchMap(function (isConfirmed) {
            if (isConfirmed) {
                return _this.getDownloadUrl(categoryId, attachmentId, entityId, fieldId).pipe(operators_1.map(function (downloadUrl) { return _this.documentService.downloadDocument(downloadUrl, model_1.FileType.ORIGINAL); }));
            }
            else {
                return Observable_1.Observable.of(attachmentId).pipe(operators_1.map(function (id) { return _this.documentService.downloadTempDocument(id); }));
            }
        }));
    };
    HttpDocumentOperationsService.prototype.previewDocument = function (attachmentId, categoryId, entityId, fieldId) {
        return this.getBlobToPreview(categoryId, attachmentId, entityId, fieldId).pipe(operators_1.map(function (blob) { return static_method_1.previewDocument(blob); }));
    };
    // tslint:disable-next-line:max-line-length
    HttpDocumentOperationsService.prototype.convertDocument = function (attachmentId, categoryId, entityId, fieldId, targetExtension, operationDto) {
        var _this = this;
        if (operationDto === void 0) { operationDto = new convert_operation_dto_1.ConvertOperationDto(); }
        return this.serviceUrl$.pipe(operators_1.switchMap(function (serviceUri) {
            var pdfDocumentUrl = _this.documentConvertPath.replaceTemplate({
                'serviceUri': serviceUri
            });
            var headers = new http_1.HttpHeaders().set('Content-Type', 'application/json');
            return _this.documentService.getIsDocumentPresent(attachmentId).pipe(operators_1.switchMap(function (isConfirmed) {
                if (isConfirmed) {
                    return _this.deService.getDocumentToken(categoryId, entityId, fieldId).pipe(operators_1.switchMap(function (token) {
                        var params = new http_1.HttpParams()
                            .set('documentId', attachmentId.toString())
                            .set('targetExtension', targetExtension)
                            .set('authInfo', token);
                        return _this.http.post(pdfDocumentUrl, operationDto, { headers: headers, params: params });
                    }));
                }
                else {
                    var params = new http_1.HttpParams()
                        .set('documentId', attachmentId.toString())
                        .set('targetExtension', targetExtension);
                    return _this.http.post(pdfDocumentUrl, operationDto, { headers: headers, params: params });
                }
            }));
        }));
    };
    // tslint:disable-next-line:max-line-length
    HttpDocumentOperationsService.prototype.convertDocumentPage = function (attachmentId, currentPage, categoryId, entityId, fieldId, targetExtension, operationDto) {
        var _this = this;
        if (operationDto === void 0) { operationDto = new convert_operation_dto_1.ConvertOperationDto(); }
        return this.serviceUrl$.pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.documentConvertPagePath.replaceTemplate({
                'serviceUri': serviceUri
            });
            var headers = new http_1.HttpHeaders().set('Content-Type', 'application/json');
            return _this.documentService.getIsDocumentPresent(attachmentId).pipe(operators_1.switchMap(function (isConfirmed) {
                if (isConfirmed) {
                    return _this.deService.getDocumentToken(categoryId, entityId, fieldId).pipe(operators_1.switchMap(function (token) {
                        var params = new http_1.HttpParams()
                            .set('documentId', attachmentId.toString())
                            .set('currentPage', currentPage.toString())
                            .set('targetExtension', targetExtension)
                            .set('authInfo', token);
                        return _this.http.post(url, operationDto, { headers: headers, params: params });
                    }));
                }
                else {
                    var params = new http_1.HttpParams()
                        .set('documentId', attachmentId.toString())
                        .set('currentPage', currentPage.toString())
                        .set('targetExtension', targetExtension);
                    return _this.http.post(url, operationDto, { headers: headers, params: params });
                }
            }));
        }), operators_1.catchError(function (err) {
            return Observable_1.Observable.throw(err);
        }));
    };
    HttpDocumentOperationsService.prototype.createDocument = function (editOperationDto, targetExtension) {
        var _this = this;
        return this.serviceUrl$.pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.createDocumentPath.replaceTemplate({
                'serviceUri': serviceUri
            });
            var headers = new http_1.HttpHeaders().set('Content-Type', 'application/json');
            var params = new http_1.HttpParams().set('targetExtension', targetExtension);
            return _this.http.post(url, editOperationDto, { headers: headers, params: params });
        }), operators_1.catchError(function (err) {
            return Observable_1.Observable.throw(err);
        }));
    };
    HttpDocumentOperationsService.prototype.getDocument = function (attachmentId, categoryId, entityId, fieldId) {
        var _this = this;
        return this.getUrl(attachmentId, categoryId, entityId, fieldId).pipe(operators_1.switchMap(function (downloadUrl) { return _this.getBlob(downloadUrl); }));
    };
    /**
     * Gets temporary download URL for the given confirmed document. Can be used as tempUrl for downloadDocument.
     * @param categoryId
     * @param attachmentId
     * @param entityId
     * @param fieldId
     * @private
     */
    HttpDocumentOperationsService.prototype.getDownloadUrl = function (categoryId, attachmentId, entityId, fieldId) {
        var _this = this;
        return this.deService.getDocumentToken(categoryId, entityId, fieldId).pipe(operators_1.switchMap(function (token) {
            return _this.documentService.getDownloadUrl(attachmentId, token);
        }));
    };
    HttpDocumentOperationsService.prototype.getBlobToPreview = function (categoryId, attachmentId, entityId, fieldId) {
        var _this = this;
        return this.getInfo(attachmentId).pipe(operators_1.switchMap(function (info) {
            var fileExtension = info.name.split('.').pop();
            var canBrowserPreview = static_method_1.isPdf(fileExtension) || static_method_1.isImage(fileExtension) || static_method_1.isTxt(fileExtension);
            if (canBrowserPreview) {
                return _this.getUrl(attachmentId, categoryId, entityId, fieldId).pipe(operators_1.switchMap(function (downloadUrl) { return _this.getBlob(downloadUrl); }));
            }
            else if (static_method_1.mustConvertedToPdf(fileExtension)) {
                return _this.convertDocument(attachmentId, categoryId, entityId, fieldId, 'pdf').pipe(operators_1.switchMap(function (data) {
                    var base64 = data.content;
                    var contentType = data.contentMimeType;
                    return static_method_1.base64toBlob(base64, contentType);
                }));
            }
            return _this.messageService.getMessage('cms_file_preview_not_available_warning').pipe(operators_1.switchMap(function (message) {
                return Observable_1.Observable.of(new Blob([message]));
            }));
        }));
    };
    HttpDocumentOperationsService.prototype.getBlob = function (documentUrl) {
        return this.http.get(documentUrl, { responseType: 'blob' });
    };
    HttpDocumentOperationsService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient,
            idm_de_service_client_js_1.DeService,
            idm_authentication_client_js_1.CookieService,
            idm_message_language_service_client_js_1.MessageService,
            idm_document_service_client_js_1.DocumentService,
            idm_kb_service_client_js_1.KbService,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpDocumentOperationsService);
    return HttpDocumentOperationsService;
}());
exports.HttpDocumentOperationsService = HttpDocumentOperationsService;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=http-document-operations.service.js.map